<app-grid
  *ngIf="(gridColumns$ | async) && (gridOptions$ | async)"
  [data]="gridData"
  [columns]="gridColumns$ | async"
  [options]="gridOptions$ | async"
></app-grid>

<ng-template #statusTemplate let-context>
  <app-chip
    *ngLet="(context.data.status | warningStatus: dprDetails.lockedDate) as warningStatus"
    size="small"
    [matTooltip]="warningStatus?.text"
    [icon]="warningStatus?.icon"
    [color]="warningStatus?.color"
  ></app-chip>
</ng-template>

<ng-template #durationTemplate let-context>
  <span>{{(context.data.start | duration: context.data.finish) }}</span>
</ng-template>

<ng-template #calculatedCustomDataTemplate let-context>
  <span>
    {{ (subprojectConfiguration.calculatedCustomDataConfiguration.customDataId | calculatedCustomData :
    context.data.dprActivityCustomDataList : context.data.start : context.data.finish: context.data.activityId) }}
  </span>
</ng-template>

<ng-template #customDataFormulaTemplate let-context>
  <span>
    {{ (subprojectConfiguration.customDataFormulaConfiguration | customDataFormula :
    context.data.dprActivityCustomDataList : context.data.activityId : projectSetup.customDataList) }}
  </span>
</ng-template>

<ng-template #infoTemplate let-context>
  <div class="d-flex no-truncate buttonsWrapper">
    <button
      *ngIf="(context.data?.dprActivityCustomDataList | arrayRemoveFalsyValues : 'value')?.length"
      mat-icon-button
      color="primary"
      class="flex-initial squareIconButton"
      [disabled]="isHandset"
      (click)="context.cell.actions.startEdit({selectedTab: DprActivityData.CustomData})"
      data-testId="info"
    >
      <mat-icon
        matTooltip="Custom Data"
        i18n-matTooltip="@@dprDetails.dprActivitiesGrid.attrCustomData"
        svgIcon="tag-multiple"
      ></mat-icon>
    </button>
    <button
      *ngIf="context.data?.dprSubActivities?.length"
      mat-icon-button
      color="primary"
      class="flex-initial squareIconButton"
      [disabled]="isHandset"
      (click)="context.cell.actions.startEdit({selectedTab: DprActivityData.Subactivities})"
      data-testId="info"
    >
      <mat-icon
        matTooltip="Sub Activities"
        i18n-matTooltip="@@dprDetails.dprActivitiesGrid.attrSubActivities"
        svgIcon="format-align-left"
      ></mat-icon>
    </button>
    <button
      *ngIf="context.data?.dprActivityAttachments?.length"
      mat-icon-button
      color="primary"
      class="flex-initial squareIconButton"
      [disabled]="isHandset"
      (click)="context.cell.actions.startEdit({selectedTab: DprActivityData.Attachments})"
      data-testId="info"
    >
      <mat-icon
        matTooltip="Attachments"
        i18n-matTooltip="@@dprDetails.dprActivitiesGrid.attrAttachments"
        svgIcon="paperclip"
      ></mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #actionsTemplate let-context>
  <button
    *ngIf="!isHandset"
    class="flex-initial button--square mat-secondary"
    mat-flat-button
    [matMenuTriggerFor]="activityActions"
    [disabled]="isHandset"
    data-testId="activity-actions-menu"
  >
    <mat-icon svgIcon="dots-horizontal"></mat-icon>
  </button>
  <mat-menu #activityActions="matMenu">
    <button
      mat-menu-item
      (click)="context.cell.actions.startEdit({selectedTab: DprActivityData.CustomData})"
      data-testId="details"
    >
      <mat-icon svgIcon="details"></mat-icon>
      <span i18n="@@dprDetails.dprActivitiesGrid.btnDetails">Details</span>
    </button>
    <button
      *ngIf="canEdit && activityStream?.isActive"
      mat-menu-item
      (click)="onCopyActivity(context.data)"
      data-testId="copy"
    >
      <mat-icon svgIcon="content-copy"></mat-icon>
      <span>{{StaticMessage.CopyButton | staticMessage}}</span>
    </button>
    <button mat-menu-item *ngIf="context.row.allowDeleting" (click)="context.row.actions.delete()" data-testId="delete">
      <mat-icon svgIcon="delete-forever"></mat-icon>
      <span>{{StaticMessage.DeleteButton| staticMessage}}</span>
    </button>
  </mat-menu>
</ng-template>

<ng-template #sortTemplate let-sortSettings>
  <button color="primary" mat-button [matMenuTriggerFor]="sortOptionsMenu" data-testId="select-sort">
    <mat-icon [ngClass]="{'mr-0': isHandset}" [svgIcon]="selectedSortOption.icon"></mat-icon>
    <span *ngIf="!isHandset" class="alignSortText" [attr.data-testId]="selectedSortOption.name">
      {{selectedSortOption.name}}
    </span>
    <mat-icon class="iconRight" [ngClass]="{'ml-0': isHandset}" svgIcon="menu-down"></mat-icon>
  </button>
  <mat-menu #sortOptionsMenu="matMenu">
    <ng-container *ngFor="let option of sortOptions">
      <button
        mat-menu-item
        *ngIf="selectedSortOption !== option"
        (click)="onSortOptionChanged(option)"
        [attr.data-testId]="option.name"
      >
        <mat-icon [svgIcon]="option.icon"></mat-icon>
        {{option.name}}
      </button>
    </ng-container>
  </mat-menu>
</ng-template>

<ng-template #copyActivitiesTemplate>
  <ng-container
    *ngIf="isAppOnline && selectedSubproject.dprScreen === Rights.Edit &&
          !selectedSubproject.isLocked && selectedSavedActivities?.length as selectedRowsCount"
  >
    <button
      mat-flat-button
      color="primary"
      class="mat-secondary"
      data-testId="grid-bulk-copy"
      (click)="onCopySelectedActivities()"
    >
      <mat-icon
        [ngClass]="{'mr-0': isHandset}"
        [svgIcon]="(gridOptions$ | async)?.icons?.copyButton ?? 'content-copy'"
      ></mat-icon>
      <span *ngIf="!isHandset">{{(gridOptions$ | async)?.labeling?.copyButton ?? 'Copy'}} ({{selectedRowsCount}})</span>
    </button>
  </ng-container>
</ng-template>

<ng-template #customDataNotApplicableTemplate>-</ng-template>

<ng-template #timeComponent let-context>
  <app-time [time]="context.selectedTime" (timeChanged)="context.timeChanged($event)"></app-time>
</ng-template>

<ng-template #addDialogButtonTemplate>
  <button
    mat-flat-button
    [matTooltip]="addShortcutTooltip ?? 'Add Entry (Shift and +)'"
    class="floatingAddButton qa-dprs-floating-add-btn"
    color="primary"
    (click)="openAddNewEntry()"
  >
    <mat-icon svgIcon="add"></mat-icon>
  </button>
</ng-template>

<ng-template #importActivitiesTemplate>
  <ng-container
    *ngIf="selectedSubproject.dprScreen === Rights.Edit &&
          !selectedSubproject.isLocked && !isHandset"
  >
    <button
      mat-flat-button
      color="primary"
      class="mat-secondary"
      data-testId="grid-import"
      (click)="onImportActivities()"
    >
      <mat-icon
        [ngClass]="{'mr-0': isHandset}"
        [svgIcon]="(gridOptions$ | async)?.icons?.importButton ?? 'file-import'"
      ></mat-icon>
      <span *ngIf="!isHandset">
        {{(gridOptions$ | async)?.labeling?.importButton ?? (StaticMessage.ImportButton | staticMessage)}}
      </span>
    </button>
  </ng-container>
</ng-template>
